import { createGlobalStyle } from 'styled-components';

import { customProperties } from './custom-properties';

export default createGlobalStyle`
  ${customProperties};

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html,
  body,
  .root {
    height: 100%;
  }

  html {
    font-size: 100%;
    -webkit-text-size-adjust: 100%;
    background-color: var(--c-mainnav-bg);
  }

  body {
    margin: 0;
    background-color: var(--c-bg-main);
    color: var(--c-text-main);
    font-family: var(--font-family);
    font-weight: var(--font-weight-body);
    font-size: ${(props) => props.theme.font.size.regular};
    line-height: ${(props) => props.theme.font.lineHeight.main};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-print-color-adjust: exact; // Make printed document look like the rendered page

    &:has(.mobile-nav-open) {
      overflow: hidden;
    }
  }

  a img {
    border: 0;
  }

  abbr {
    text-decoration: none;
  }

  button,
  input,
  textarea,
  select {
    font-family: var(--font-family);
    font-weight: var(--font-weight-regular);
  }

  b,
  strong {
    font-weight: var(--font-weight-strong);
  }

  // Remove inner focus on buttons in Firefox
  ::-moz-focus-inner {
    border: none;
  }

  // Remove default focus outline
  :focus {
    outline: none;
  }

  // Add custom default focus to focusable elements
  :where(a, button, input, select, textarea, summary, [role="button"]) {
    --focus-outline-size: max(2px, 0.08em);
    --focus-outline-style: solid;
    --focus-outline-color: var(--c-focus);

    @supports selector(:focus-visible) {
      &:focus-visible {
        outline: var(--focus-outline-size) var(--focus-outline-style) var(--focus-outline-color);
        outline-offset: var(--focus-outline-offset, var(--focus-outline-size));
      }
    }

    // Safari & IE11
    @supports not selector(:focus-visible) {
      &:focus {
        outline: var(--focus-outline-size) var(--focus-outline-style) var(--focus-outline-color);
        outline-offset: var(--focus-outline-offset, var(--focus-outline-size));
      }
    }
  }

  .sortable-dragged-in-panel {
    z-index: ${(props) => props.theme.zindex.panelSortableItem};
    list-style: none;
  }

  // Overwrite position of Hubspot floating chat bubble
  // This is done to prevent it to be placed on top of Dealer actions and adjust position to the main navigation
  #hubspot-messages-iframe-container#hubspot-messages-iframe-container {
    z-index: ${(props) => props.theme.zindex.floatingChatBubble} !important;

    ${(props) => props.theme.breakpoint.Md} {
      --_hubspot-chat-width: 60px; // Width of the chat button (magic number)
      --_hubspot-chat-padding-inline: 16px; // Padding around the chat button (magic number)
      --_main-nav-width: 104px; // Width of the main navigation (magic number)
      left: calc((var(--_main-nav-width) - var(--_hubspot-chat-width) - (var(--_hubspot-chat-padding-inline) * 2)) * 0.5) !important;
    }
  }

  // Overwrite position of UserGuiding floating button
  #userguiding {
    position: relative;
    z-index: 1;
  }
`;
